// extracted by mini-css-extract-plugin
module.exports = {"root":"BaseFilterBar_root__2Goe6"};